<!--大屏展示 有侧边的页面-->
<template>
    <div class="l-sider-all-box">
      <!--    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:1080px;position:fixed; z-index:3; " @click="getClickInfo" :scroll-wheel-zoom='true'>-->
      <!--    </baidu-map>-->
      <!--    <LargerScreen></LargerScreen>-->
      <LargerScreenPage></LargerScreenPage>

    </div>

</template>

<script>

  import LargerScreen from '../../components/largerScreen'
  import LargerScreenPage from './largerScreenPage'

  export default {
    name: 'LargerSiderPage',
    components: {
      LargerScreen,
      LargerScreenPage
    },
    data() {
      return {
        center: {lng: 109.45744048529967, lat: 36.49771311230842},
        zoom: 13
      }
    },
    mounted () {


      },
    methods: {
      handler ({BMap, map}) {
        var point = new BMap.Point(109.49926175379778, 36.60449676862417)
        map.centerAndZoom(point, 13)
        var marker = new BMap.Marker(point) // 创建标注
        map.addOverlay(marker) // 将标注添加到地图中
        var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
        map.addOverlay(circle)
      },
      getClickInfo (e) {

        this.center.lng = e.point.lng
        this.center.lat = e.point.lat
      }
    }
  }
</script>

